import { render, staticRenderFns } from "./BackgroundReverse.vue?vue&type=template&id=09120f88&"
import script from "./BackgroundReverse.vue?vue&type=script&lang=js&"
export * from "./BackgroundReverse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports